import React, {
  useMemo,
} from 'react';
import classnames from 'classnames';

import Image from 'components/Image';
import { HIDDEN_CATEGORIES } from 'constants/qualityRequirements';
import { stripHtml } from 'utils/stringFunctions';

interface Props {
  data: any,
  storylet?: boolean,
  type?: string,
  tooltipPos?: string,
}

export default function QualityRequirementContainer(props: Props) {
  const {
    data,
    storylet,
    tooltipPos,
    type,
  } = props;

  const {
    availableAtMessage,
    category,
    description,
    image,
    nature,
    status,
    tooltip,
  } = data;

  const isExcluded = useMemo(() => HIDDEN_CATEGORIES.indexOf(category) >= 0, [category]);

  const qreqClass = classnames({
    icon: true,
    'icon--circular': nature === 'Status',
    'icon--locked': status === 'Locked',
    'icon--purchase': type === 'purchase',
    'quality-requirement': true,
    'quality-requirement--storylet': storylet,
  });

  const tooltipData = {
    ...data,
    description: tooltip || description,
    // If the player doesn't meet the qreq, then add the AvailableAt as a secondary description
    secondaryDescription: status === 'Locked' ? availableAtMessage : undefined,
  };

  if (isExcluded) {
    return null;
  }

  return (
    <div className={qreqClass}>
      <Image
        icon={image}
        alt={stripHtml(tooltip)}
        type="small-icon"
        tooltipData={tooltipData}
        tooltipPos={tooltipPos}
        defaultCursor
      />
    </div>
  );
}

QualityRequirementContainer.displayName = 'QualityRequirementContainer';
